import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconCheck = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_check_light"
      data-name="UI icon/check/light"
      xmlns="http://www.w3.org/2000/svg"
      width="16.167"
      height="11.31"
      viewBox="0 0 16.167 11.31"
    >
      <path
        id="Vector_408_Stroke_"
        data-name="Vector 408 (Stroke)"
        d="M15.888.3a1.059,1.059,0,0,1,0,1.432L7.723,10.42a2.732,2.732,0,0,1-4.035,0L.279,6.79a1.059,1.059,0,0,1,0-1.432.911.911,0,0,1,1.345,0l3.41,3.63a.911.911,0,0,0,1.345,0L14.543.3A.911.911,0,0,1,15.888.3Z"
        fill={color}
      />
    </svg>
  );
};

export default IconCheck;
